import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Search, User, Menu, X, Heart } from 'lucide-react';
import { useWishlist } from '../hooks/useWishlist';

const navItems = [
  { label: 'TURLAR', to: '/turlar', testId: 'nav-tours' },
  { label: 'ROTALAR', to: '/turlar', testId: 'nav-routes' },
  { label: 'TAKVİM', to: '/takvim', testId: 'nav-calendar' },
  { label: 'BLOG', to: '/blog', testId: 'nav-blog' },
  { label: 'HAKKIMIZDA', to: '/hakkimizda', testId: 'nav-about' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { count: wishlistCount } = useWishlist();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Announcement Banner */}
      <div className="bg-[#3D4A26] text-white text-center py-2 px-4 text-sm font-medium tracking-wide z-50 relative">
        <a href="#sale" className="hover:underline">
          <span className="font-bold">2026 SONBAHAR ERKEN REZERVASYON!</span>
          <span className="block text-xs mt-0.5 uppercase tracking-wider">TÜM TURLARDA %20&apos;YE VARAN İNDİRİM</span>
        </a>
      </div>

      {/* Main Navbar */}
      <nav
        className={`sticky top-0 z-50 transition-shadow duration-300 bg-white ${
          scrolled ? 'shadow-md' : ''
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-[72px]">
            {/* Logo */}
            <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 flex-shrink-0">
              <svg width="40" height="40" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Camption" role="img">
                <circle cx="32" cy="32" r="22" fill="none" stroke="#3D4A26" strokeWidth="8" strokeLinecap="round" strokeDasharray="104 138" transform="rotate(38 32 32)"/>
                <circle cx="32" cy="32" r="6" fill="#B8734A"/>
              </svg>
              <span
                className="text-lg text-[#3D4A26]"
                style={{ fontFamily: "'Archivo', Helvetica, Arial, sans-serif", fontWeight: 500, letterSpacing: '0.12em' }}
              >
                CAMPTION
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.to}
                  data-testid={item.testId}
                  className="text-[13px] font-semibold text-[#1B1B1B] tracking-[0.08em] hover:text-[#3D4A26] transition-colors duration-200"
                  style={{ fontFamily: 'DM Sans, sans-serif' }}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* Right Icons */}
            <div className="flex items-center gap-3">
              <Link
                to="/favoriler"
                data-testid="nav-wishlist"
                className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
                aria-label="Beğendiklerim"
                title="Beğendiklerim"
              >
                <Heart size={20} className="text-[#1B1B1B]" fill={wishlistCount > 0 ? '#ef4444' : 'transparent'} stroke={wishlistCount > 0 ? '#ef4444' : 'currentColor'} />
                {wishlistCount > 0 && (
                  <span
                    data-testid="wishlist-count-badge"
                    className="absolute -top-0.5 -right-0.5 bg-[#ef4444] text-white text-[10px] font-bold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center leading-none"
                  >
                    {wishlistCount}
                  </span>
                )}
              </Link>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Ara">
                <Search size={20} className="text-[#1B1B1B]" />
              </button>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Hesap">
                <User size={20} className="text-[#1B1B1B]" />
              </button>
              <button
                className="lg:hidden p-2 hover:bg-gray-100 rounded-full transition-colors"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Menü"
                data-testid="mobile-menu-toggle"
              >
                {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
            <div className="px-4 py-4 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.to}
                  data-testid={`${item.testId}-mobile`}
                  className="block px-4 py-3 text-[13px] font-semibold text-[#1B1B1B] tracking-[0.08em] hover:bg-gray-50 rounded-lg transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;
